import React, { useEffect, useState } from 'react';
import { LinearProgress, linearProgressClasses, styled } from '@mui/material';
import { Colors } from 'library';

interface RProgressBarProps {
    value: number;
    max?: number;
    height?: number;
    color?: string;
    backgroundColor?: string;
    outlineColor?: string;
}

export function RProgressBar({
    value,
    max = 100,
    height = 10,
    color = Colors.turquoise,
    backgroundColor = Colors.lightGrey,
    outlineColor = 'none',
}: RProgressBarProps) {
    const clamped = Math.max(0, Math.min(value, max));
    const percent = max > 0 ? (clamped / max) * 100 : 0;
    const [displayValue, setDisplayValue] = useState(0);
    const outline = outlineColor !== 'none' ? `1px solid ${outlineColor}` : 'none';

    useEffect(() => {
        const frame = requestAnimationFrame(() => setDisplayValue(percent));
        return () => cancelAnimationFrame(frame);
    }, [percent]);

    return (
        <StyledLinearProgress
            variant="determinate"
            value={displayValue}
            barHeight={height}
            barColor={color}
            backgroundColor={backgroundColor}
            outline={outline}
        />
    );
}

const StyledLinearProgress = styled(LinearProgress, {
    shouldForwardProp: (prop) => prop !== 'barHeight' && prop !== 'barColor',
})<{ barHeight: number; barColor: string; backgroundColor: string; outline: string }>(
    ({ barHeight, barColor, backgroundColor, outline }) => ({
        flex: 1,
        height: barHeight,
        borderRadius: 999,
        backgroundColor: backgroundColor,
        border: outline,
        [`& .${linearProgressClasses.bar}`]: {
            borderRadius: 999,
            backgroundColor: barColor,
            transition: 'transform 800ms cubic-bezier(0.4, 0, 0.2, 1)',
        },
    }),
);
